import { createRouter, createWebHistory } from 'vue-router';

import HomeVie from '../views/HomeVie.vue';
import LoginVie from '../views/LoginVie.vue';
import RegisterVie from '../views/RegisterVie.vue';
import CandidatosVagaVie from '../views/CandidatosVagaVie.vue';
import NovaVagaVie from '../views/NovaVagaVie.vue';
import UserDashboardVie from '../views/UserDashboardVie.vue';
import AdminDashboardVie from '../views/AdminDashboardVie.vue';
import VagaDetalheVie from '../views/VagaDetalheVie.vue';
import EditarVagaVie from '../views/EditarVagaVie.vue';
import UsuarioListaVie from '../views/UsuarioListaVie.vue';
import UsuarioPerfilVie from '../views/UsuarioPerfilVie.vue';
import NotificacoesVie from '../views/NotificacoesVie.vue';
import RelatoriosVie from '../views/RelatoriosVie.vue';
import EsqueciSenhaVie from "../views/EsqueciSenhaVie.vue";
import RedefinirSenhaVie from "../views/RedefinirSenhaVie.vue";


const routes = [
  { 
    path: "/esqueci-senha", 
    name: "EsqueciSenha", 
    component: EsqueciSenhaVie 
  },
  {
    path: "/redefinir-senha",
    name: "RedefinirSenha",
    component: RedefinirSenhaVie,
  },
  {
    path: '/',
    name: 'HomeVie',
    component: HomeVie,
  },
  {
    path: '/login',
    name: 'LoginVie',
    component: LoginVie,
  },
  {
    path: '/register',
    name: 'RegisterVie',
    component: RegisterVie,
  },
  {
    path: '/dashboard',
    name: 'UserDashboardVie',
    component: UserDashboardVie,
  },
  {
    path: '/relatorios',
    name: 'RelatoriosVie',
    component: RelatoriosVie,
  },
  {
    path: '/admin',
    name: 'AdminDashboardVie',
    component: AdminDashboardVie,
  },
  {
    path: '/admin/vaga/:id/candidatos',
    name: 'CandidatosVagaVie',
    component: CandidatosVagaVie,
  },
  {
    path: '/admin/nova-vaga',
    name: 'NovaVagaVie',
    component: NovaVagaVie,
  },
  {
    path: '/vaga/:id',
    name: 'VagaDetalheVie',
    component: VagaDetalheVie,
  },
  {
    path: '/admin/vaga/:id/editar',
    name: 'EditarVagaVie',
    component: EditarVagaVie,
  },
  {
    path: '/admin/usuarios',
    name: 'UsuarioListaVie',
    component: UsuarioListaVie,
  },
  {
    path: '/admin/usuario/:id',
    name: 'UsuarioPerfilVie',
    component: UsuarioPerfilVie,
  },
  {
    path: '/notificacoes',
    name: 'Notificacoes',
    component: NotificacoesVie,
  },
];

const router = createRouter({
  history: createWebHistory('/oportunidades-rh/'), // define o base aqui
  routes,
});

export default router;

router.beforeEach((to, from, next) => {
  const usuario = JSON.parse(localStorage.getItem('usuario'));


  const somenteAdmin = to.path.startsWith('/admin');
  const somentecandidato = to.path === '/dashboard';

  // Se não estiver logado, redireciona para login
  if (!usuario && (somenteAdmin || somentecandidato)) {
    return next('/login');
  }

  // Se for admin e tentar acessar /dashboard (rota de candidato)
  if (usuario?.tipo === 'admin' && to.path === '/dashboard') {
    return next('/admin');
  }

  // Se for candidato e tentar acessar rota de admin
  if (usuario?.tipo === 'candidato' && somenteAdmin) {
    return next('/dashboard');
  }

  // Redirecionamento dinâmico ao entrar em /dashboard
  if (to.path === '/dashboard') {
    if (usuario?.tipo === 'admin') return next('/admin');
  }
  if (usuario && (to.path === '/login' || to.path === '/register')) {
    return next('/dashboard');
  }


  return next();
});

